// Readers for the values BigQuery rows carry, shared by the Activities and Origin-Destination
// services. No logging: rows can hold anything.

/** BigQuery sends some timestamps and numbers as `{ value: "..." }`; read through the wrapper. */
export const unwrap = (v: unknown): unknown =>
  v !== null && typeof v === 'object' && 'value' in v ? (v as { value: unknown }).value : v;

/** null for a missing value and for text that is not a number; never NaN and never 0 by default. */
export const nullableNumber = (raw: unknown): number | null => {
  const v = unwrap(raw);
  if (v == null || (typeof v === 'string' && v.trim() === '')) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

export const text = (raw: unknown): string => {
  const v = unwrap(raw);
  return v == null ? '' : String(v);
};
